import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ProfileMenuAction {
  action?: 'addFunds' | 'withdraw';
}

@Injectable({
  providedIn: 'root'
})
export class ProfileMenuService {
  private readonly openProfileMenuSubject = new Subject<ProfileMenuAction>();
  readonly openProfileMenu$ = this.openProfileMenuSubject.asObservable();

  private readonly openWithdrawalMenuSubject = new Subject<ProfileMenuAction>();
  readonly openWithdrawalMenu$ = this.openWithdrawalMenuSubject.asObservable();

  private readonly dashboardBannerRefreshSubject = new Subject<void>();
  readonly dashboardBannerRefresh$ = this.dashboardBannerRefreshSubject.asObservable();

  openProfileMenu(options?: ProfileMenuAction): void {
    this.openProfileMenuSubject.next(options || {});
  }

  openWithdrawalMenu(options?: ProfileMenuAction): void {
    this.openWithdrawalMenuSubject.next(options || {});
  }

  requestDashboardBannerRefresh(): void {
    this.dashboardBannerRefreshSubject.next();
  }
}
